module.exports = __webpack_public_path__ + "media/public/fonts/PragmaticaSlabLight/PragmaticaSlabLight-6e482c6bd30dc725587d42550b2acfd2.woff";